module.exports = __webpack_public_path__ + "img/39_67.8c84a62c.png";